/**
 * Normalise une saisie de relevé sur un bon de travail.
 * Le compteur courant ne sert pas de plancher : les heures ne sont injectées
 * qu'à l'approbation, où les voisins sont validés. Seules les valeurs négatives
 * sont ramenées à zéro.
 */
export function normaliserValeurSaisieReleve(valeur: number | null | undefined): number | null | undefined {
  if (valeur == null || Number.isNaN(valeur)) {
    return valeur;
  }
  return valeur < 0 ? 0 : valeur;
}
